import * as turf from "@turf/turf";
import { FeatureCollection } from "geojson";
import { useCallback } from "react";
import { useMap } from "react-map-gl/maplibre";
import { useIsochrone } from "../../store/slices/campgroundSearch";

const useZoomToIsochrone = () => {
  const isochrone = useIsochrone();
  const { main: map } = useMap();

  return useCallback(() => {
    if (!isochrone) return;
    const bbox = turf.bbox(isochrone as FeatureCollection);
    map?.fitBounds(
      [
        [bbox[0], bbox[1]],
        [bbox[2], bbox[3]],
      ],
      {
        padding: 100,
      }
    );
  }, [map, isochrone]);
};

export default useZoomToIsochrone;
